module.exports = __webpack_public_path__ + "static/media/nora-bg.54ecdd95.mp4";